<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" @click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Выберите пользователя
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-text">
                {{description}}
            </div>
            <div class="filter-selects" v-show="showFilter">
                <div class="ap-filter-section-name">
                    Выберите переметры пользователя:
                </div>
                <div class="sidebar-borderline"></div>
                <SelectRegionCity :selectedRegionID="selectedParamValueRegion" :selectedCityID="selectedParamValueCity"
                                  @regionSelected="selectRegion" @citySelected="selectCity"/>
                <div class="ap-modal-input-name">
                    Организация
                </div>
                <JHCustomSelect v-model="inputOrganizationName"
                                :selectOptions="optionsOrganizations"
                                :selectName="(organization, key) => organization.name"
                                :selectableParamCondition="(organization, key) => organization.id"
                                :selectedParamValue="selectedParamValueOrganization"
                                @selected="selectOrganization"
                                :visibleMessageLoading="waitingResponseToOrganizationRequest"
                />
                <div class="sidebar-borderline"></div>
            </div>
            <div class="ap-modal-input-name">
                Ответственный <span class="red-text">*</span>
            </div>
            <div class="select-filter-grid">
                <JHCustomSelect v-model="inputUserName"
                                :selectOptions="optionsUsers"
                                :selectName="(user, key) => user.fullname"
                                :selectableParamCondition="(user, key) => user.id"
                                :selectedParamValue="selectedParamValueUser"
                                @selected="selectUser"
                                @scrollReachEnd="scrollReachEndUsers"
                                @focusOnInput="updateUsers"
                                :visibleMessageLoading="waitingResponseToUserRequest"
                />
                <div class="filter-btn" v-on:click="showFilter = !showFilter">
                    <SVGFilter class="filter-svg"/>
                </div>
            </div>
            <div class="form-alert-danger" v-show="showAlert === 'responsibleUser'">
                Обязательное поле!
            </div>
        </div>
        <div class="modal-button" v-on:click="apply">
            Подтвердить
        </div>
    </div>
</template>

<script>
import SVGModalClose from "../../SVG/SVGModalClose";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import SVGFilter from "../../SVG/SVGFilter";
import SVGDropdownSwitchArrowUp from "../../SVG/SVGDropdownSwitchArrowUp";
import SVGDropdownSwitchArrowDown from "../../SVG/SVGDropdownSwitchArrowDown";
import JHCustomSelect from "../../TemplatesLibrary/JHCustomSelect";
import SelectRegionCity from "./SelectRegionCity";

export default {
    name: "ModalSelectUser",
    components: {
        SelectRegionCity,
        JHCustomSelect,
        SVGDropdownSwitchArrowDown,
        SVGDropdownSwitchArrowUp,
        SVGFilter,
        SVGModalClose,
        vSelect
    },
    props: {
        description: {
            type: String,
            default: ''
        },
        callback: {
            type: Function
        }
    },
    data() {
        return {
            showAlert: null,
            showFilter: false,

            userTimerId: null,
            cityTimerId: null,
        }
    },
    computed: {
        inputUserName: {
            get() {
                return this.$store.state.adminPanel.selectUser.users.mask;
            },
            set(value) {
                this.$store.commit('adminPanel/selectUser/users/MASK', value);
                if (this.userTimerId) {
                    clearTimeout(this.userTimerId);
                    this.userTimerId = null;
                }
                this.userTimerId = setTimeout(() => {
                    this.$store.commit('adminPanel/selectUser/users/CLEAR_USERS');
                    this.$store.dispatch('adminPanel/selectUser/GET_USERS_BY_SELECT_CATEGORIES');
                    this.userTimerId = null;
                }, 500);
            }
        },

        inputOrganizationName: {
            get() {
                return this.$store.state.adminPanel.selectUser.organizations.mask;
            },
            set(value) {
                this.$store.commit('adminPanel/selectUser/organizations/MASK', value);
            }
        },

        selectedParamValueUser: {
            get() {
                return this.$store.state.adminPanel.selectUser.selectedUserID;
            },
            set(value) {
                this.$store.commit('adminPanel/selectUser/SELECTED_USER_ID', value);
            }
        },
        selectedParamValueCity: {
            get() {
                return this.$store.state.adminPanel.selectUser.selectedCityID;
            },
            set(value) {
                this.$store.commit('adminPanel/selectUser/SELECTED_CITY_ID', value);
            }
        },
        selectedParamValueRegion: {
            get() {
                return this.$store.state.adminPanel.selectUser.selectedRegionID;
            },
            set(value) {
                this.$store.commit('adminPanel/selectUser/SELECTED_REGION_ID', value);
            }
        },
        selectedParamValueOrganization: {
            get() {
                return this.$store.state.adminPanel.selectUser.selectedOrganizationID;
            },
            set(value) {
                this.$store.commit('adminPanel/selectUser/SELECTED_ORGANIZATION_ID', value);
            }
        },


        waitingResponseToUserRequest() {
            return this.$store.state.adminPanel.selectUser.users.waitingResponseToUserRequest;
        },
        waitingResponseToOrganizationRequest() {
            return this.$store.state.adminPanel.selectUser.organizations.waitingResponseToOrganizationRequest;
        },

        optionsUsers() {
            return this.$store.getters["adminPanel/selectUser/users/SELF"];
        },
        optionsOrganizations() {
            return this.$store.getters["adminPanel/selectUser/ORGANIZATIONS_T"];
        },
    },
    methods: {
        updateUsers(status) {
            if(status) {
                this.$store.commit('adminPanel/selectUser/users/CLEAR_USERS', '');
                this.$store.dispatch('adminPanel/selectUser/GET_USERS_BY_SELECT_CATEGORIES');
            }
        },

        scrollReachEndUsers() {
            this.$store.dispatch('adminPanel/selectUser/GET_USERS_BY_SELECT_CATEGORIES');
        },

        selectUser(selectedParam) {
            this.selectedParamValueUser = selectedParam;
        },
        selectCity(selectedParam) {
            this.selectedParamValueCity = selectedParam;
        },
        selectRegion(selectedParam) {
            this.selectedParamValueRegion = selectedParam;
        },
        selectOrganization(selectedParam) {
            this.$store.commit('adminPanel/selectUser/organizations/MASK', '');
            this.selectedParamValueOrganization = selectedParam;
        },
        async apply() {
            const selectUserID = this.$store.getters["adminPanel/selectUser/SELECTED_USER_ID"];
            if (!selectUserID) {
                this.showAlert = 'responsibleUser';
                return;
            }

            await this.callback(selectUserID);
            this.$emit('close');
        }
    },
    async mounted() {
        await this.$store.dispatch('adminPanel/selectUser/organizations/GET_ORGANIZATIONS');
    },
    async destroyed() {
        await this.$store.dispatch('adminPanel/selectUser/CLEAR_ALL');
    }
}
</script>

<style scoped>
.filter-btn {
    display: inline-flex;
    justify-content: center;
    align-items: flex-start;
    width: 30px;
    margin: 5px;
    color: #999999;
    cursor: pointer;
    /*position: absolute;*/
}

.filter-btn:hover {
    color: #626262;
}

.filter-btn:active {
    color: #999999;
}

.filter-svg {
    width: 22px;
    height: 22px;
}

.width-360 {
    width: 360px;
    display: inline-block;
}

.ap-filter-section-name {
    position: relative;
    font-size: 14px;
    background-color: white;
    color: #939393;
    padding: 2px;
    top: 26px;
    left: 7px;
    width: max-content;
    z-index: 2;
}

.select-filter-grid {
    display: grid;
    grid-template-columns: 370px auto;
}
</style>
